module.exports = __webpack_public_path__ + "img/sbl0002.ade53140.png";